export default {
      id: "phone-down-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#phone-down-usage",
      toString: function () {
        return this.url;
      }
    }